import { FC, useEffect } from 'react';
import { useToast } from '@/contexts/ToastContext';

/**
 * Mostra toast quando o backend retorna 403 `agent_feature_not_enabled`.
 *
 * AgentRoute cobre o caso "user clica em link/abre URL" (redirect + toast in-line).
 * Este host cobre **race condition**: admin desliga a flag enquanto user está
 * dentro do Hub. Próxima chamada API retorna 403, o interceptor (api.service)
 * dispara `agent-feature-blocked` event, e o toast aqui aparece.
 *
 * Mantido em arquivo separado pra ser mountado uma vez no `AppLayout` (dentro
 * do `ToastProvider`).
 */
const AgentFeatureBlockedHost: FC = () => {
  const { showToast } = useToast();

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ message?: string }>).detail;
      showToast(
        detail?.message ||
          'Acesso ao Hub de Agentes foi desligado pra você. Fale com seu admin.',
        'warning',
      );
    };
    window.addEventListener('agent-feature-blocked', handler);
    return () => window.removeEventListener('agent-feature-blocked', handler);
  }, [showToast]);

  return null;
};

export default AgentFeatureBlockedHost;
